module.exports = __webpack_public_path__ + "static/media/196-azores-islands.0b716ee1.svg";